import React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { useAppContext } from "../../../context/AppContext";

import nothing_imgs from "../../../resources/images/i_retiro.png";
import PropTypes from "prop-types";
const useStyles = makeStyles(() => ({
  imgDark: {
    filter: "invert(100%);",
    width: "50%",
    marginBottom: 20,
    opacity: 0.8,
  },
  imgLight: {
    width: "50%",
    marginBottom: 20,
    opacity: 0.6,
  },
}));
export default function Nothing({ text }) {
  const classes = useStyles();
  const { themeColor } = useAppContext();
  return (
    <Grid container direction="column" justify="center" alignItems="center">
      <Grid item align="center" xs={6} md={3}>
        <img
          src={nothing_imgs}
          className={
            themeColor === "light" ? classes.imgLight : classes.imgDark
          }
          alt="Aquí no hay nada"
        />
      </Grid>
      <Grid item md={6} style={{ marginBottom: 10 }}>
        <Typography variant="body1" color="textSecondary" align="center">
          {text}
        </Typography>
      </Grid>
    </Grid>
  );
}

Nothing.propTypes = {
  text: PropTypes.string.isRequired,
};
